export default {
  NOTIFICATION_START: 'NOTIFICATION_START',
  NOTIFICATION_OPEN: 'NOTIFICATION_OPEN',
  NOTIFICATION_CLOSE: 'NOTIFICATION_CLOSE',
};
